import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";
import Card from "@material-ui/core/Card";
import ReactTable from "react-table";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment-timezone";


export default class MultiplePhoneLogs extends Framework.Components.Object {
	constructor(props) {

		super(props, Types.Phone_Logs._name);
		this.state.data = [];
	}

	async componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.search !== this.props.search || this.state.search !== this.props.search) {
			this.state.search = this.props.search
			if (this.timeout) clearTimeout(this.timeout);
			this.timeout = setTimeout(async () => {
				//search function
				await this.loadLogs();
			}, 750);

		}
	}

	//Grab fes for select dropdown
	async loadLogs() {
		if (!this.state.search) {
			return;
		}
		let logs = new API.BuildClass(Types.Phone_Logs._name, API.RequestType.READ_ALL);
		logs.search = this.state.search;
		logs.filter = {'phone_only': true};
		let data = await logs.submit(this, API.RequestType.READ_ALL);
		this.setState({
			data: data.items
		})
	}


	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Date",
				id: "created",
				accessor: (obj) => moment(obj.created).local().format("MM/DD/YYYY h:mm A"),
				style: { whiteSpace: "nowrap" }, // Prevent wrapping
				width: 150, // Set a minimum width
			},
			{
				Header: "Phone Number",
				id: "phone_number",
				accessor: (obj) => obj.phone_number,
				style: { whiteSpace: "nowrap" },
				width: 150, // Set a minimum width
			},
			{
				Header: "User",
				id: "user",
				accessor: (obj) => obj.users.name_first + " " + obj.users.name_last,
				style: { whiteSpace: "nowrap" },
				width: 200, // Set a minimum width
			},
			{
				Header: "Notes",
				accessor: "notes",
				style: { whiteSpace: "unset", flex: 1 }, // Allow wrapping and let this column expand
			},
		];

		return (
			<Card>
				<CardContent>
					{data.length > 0 ? <ReactTable
						key={this.state.key}
						columns={columns}
						data={data}
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						className="-striped -highlight"
						showPagination={false} // Disable the pagination
						pageSize={data.length > 15 ? 15 : data.length}
					/> : <b>There were no phone logs found for that number.</b>}

				</CardContent>
			</Card>
		)
	}
}
